
    <p>Hai cambiato la data dell'appuntamento, seleziona lo stato:</p>
    <button (click)="modal.close('scheduled')" class="btn btn-primary btn-fw mb-1">Appuntamento programmato</button>
    <button (click)="modal.close('to_be_confirmed')" class="btn btn-warning btn-fw mb-1">Richiedi conferma via SMS</button>
    <button (click)="modal.close('confirmed')" class="btn btn-success btn-fw">Appuntamento confermato</button>
  